"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _UserProfileCache_instances, _UserProfileCache_zapperQueue, _UserProfileCache_nip5Queue, _UserProfileCache_processZapperQueue, _UserProfileCache_processNip5Queue, _UserProfileCache_batchQueue;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileCache = void 0;
const _1 = require(".");
const shared_1 = require("@snort/shared");
class UserProfileCache extends shared_1.FeedCache {
    constructor() {
        super("UserCache", _1.db.users);
        _UserProfileCache_instances.add(this);
        _UserProfileCache_zapperQueue.set(this, []);
        _UserProfileCache_nip5Queue.set(this, []);
        __classPrivateFieldGet(this, _UserProfileCache_instances, "m", _UserProfileCache_processZapperQueue).call(this);
        __classPrivateFieldGet(this, _UserProfileCache_instances, "m", _UserProfileCache_processNip5Queue).call(this);
    }
    key(of) {
        return of.pubkey;
    }
    async preload(follows) {
        await super.preload();
        // load follows profiles
        if (follows) {
            await this.buffer(follows);
        }
    }
    async search(q) {
        if (_1.db.ready) {
            // on-disk cache will always have more data
            return (await _1.db.users
                .where("npub")
                .startsWithIgnoreCase(q)
                .or("name")
                .startsWithIgnoreCase(q)
                .or("display_name")
                .startsWithIgnoreCase(q)
                .or("nip05")
                .startsWithIgnoreCase(q)
                .toArray()).slice(0, 5);
        }
        else {
            return [...this.cache.values()]
                .filter(user => {
                const profile = user;
                return (profile.name?.includes(q) ||
                    profile.npub?.includes(q) ||
                    profile.display_name?.includes(q) ||
                    profile.nip05?.includes(q));
            })
                .slice(0, 5);
        }
    }
    /**
     * Try to update the profile metadata cache with a new version
     * @param m Profile metadata
     * @returns
     */
    async update(m) {
        const updateType = await super.update(m);
        if (updateType !== "refresh") {
            const lnurl = m.lud16 ?? m.lud06;
            if (lnurl) {
                __classPrivateFieldGet(this, _UserProfileCache_zapperQueue, "f").push({
                    pubkey: m.pubkey,
                    lnurl,
                });
            }
            if (m.nip05) {
                __classPrivateFieldGet(this, _UserProfileCache_nip5Queue, "f").push({
                    pubkey: m.pubkey,
                    nip05: m.nip05,
                });
            }
        }
        return updateType;
    }
    takeSnapshot() {
        return [];
    }
}
exports.UserProfileCache = UserProfileCache;
_UserProfileCache_zapperQueue = new WeakMap(), _UserProfileCache_nip5Queue = new WeakMap(), _UserProfileCache_instances = new WeakSet(), _UserProfileCache_processZapperQueue = async function _UserProfileCache_processZapperQueue() {
    await __classPrivateFieldGet(this, _UserProfileCache_instances, "m", _UserProfileCache_batchQueue).call(this, __classPrivateFieldGet(this, _UserProfileCache_zapperQueue, "f"), async (i) => {
        const svc = new shared_1.LNURL(i.lnurl);
        await svc.load();
        const p = this.getFromCache(i.pubkey);
        if (p) {
            await this.set({
                ...p,
                zapService: svc.zapperPubkey,
            });
        }
    }, 5);
    setTimeout(() => __classPrivateFieldGet(this, _UserProfileCache_instances, "m", _UserProfileCache_processZapperQueue).call(this), 1000);
}, _UserProfileCache_processNip5Queue = async function _UserProfileCache_processNip5Queue() {
    await __classPrivateFieldGet(this, _UserProfileCache_instances, "m", _UserProfileCache_batchQueue).call(this, __classPrivateFieldGet(this, _UserProfileCache_nip5Queue, "f"), async (i) => {
        const [name, domain] = i.nip05.split("@");
        const nip5pk = await (0, shared_1.fetchNip05Pubkey)(name, domain);
        const p = this.getFromCache(i.pubkey);
        if (p) {
            await this.set({
                ...p,
                isNostrAddressValid: i.pubkey === nip5pk,
            });
        }
    }, 5);
    setTimeout(() => __classPrivateFieldGet(this, _UserProfileCache_instances, "m", _UserProfileCache_processNip5Queue).call(this), 1000);
}, _UserProfileCache_batchQueue = async function _UserProfileCache_batchQueue(queue, proc, batchSize = 3) {
    const batch = [];
    while (queue.length > 0) {
        const i = queue.shift();
        if (i) {
            batch.push((async () => {
                try {
                    await proc(i);
                }
                catch {
                    console.warn("Failed to process item", i);
                }
                batch.pop(); // pop any
            })());
            if (batch.length === batchSize) {
                await Promise.all(batch);
            }
        }
        else {
            await Promise.all(batch);
        }
    }
};
//# sourceMappingURL=data:application/json;base64,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